// extracted by mini-css-extract-plugin
export var columnList = "_eo-0";